import React from 'react';
import SelectLocation from './select_location';
import PreviewLocation from './preview_location';
import './styles.scss';

export default function FindLocation({
    businessName = '',
    locations = null,
    selectedLocation = null,
    isDisabled = true,
    renderBusinessNameField,
    onChangeBusinessName,
    onSelectLocation,
    onEnterLocationManually,
    onCancelSelectLocation,
    isProcessing,
    onFocus
}) {
    return (
        <div className="FindLocation-selectAndPreviewLocation">
            {!selectedLocation ? (
                <SelectLocation
                    onFocus={onFocus}
                    businessName={businessName}
                    locations={locations}
                    isDisabled={isDisabled}
                    isProcessing={isProcessing}
                    renderBusinessNameField={renderBusinessNameField}
                    onBusinessNameChange={onChangeBusinessName}
                    onLocationSelect={onSelectLocation}
                    onEnterLocationManually={onEnterLocationManually}
                    data-hook={'selectLocationField'}
                />
            ) : null}
            {selectedLocation ? (
                <PreviewLocation
                    location={selectedLocation}
                    locationClassName={'s-mbm'}
                    isDisabled={isDisabled}
                    onRemove={onCancelSelectLocation}
                    data-hook={'previewLocation'}
                />
            ) : null}
        </div>
    );
}
